import "./welcome.scss";

import PropTypes from "prop-types";
import React, { Fragment, PureComponent } from "react";

import { PropTypeShapes } from "../../types";
import ListItemView from "../listView/ListItemView";
import ListView from "../listView/ListView";

const itemElement = (name, path) => (
  <Fragment>
    <div className="welcomeListItemName">{name}</div>
    <div className="recentFilePath">{path}</div>
  </Fragment>
);

class WelcomeFilesListView extends PureComponent {
  constructor(props) {
    super(props);

    this.fileItemRenderer = this.fileItemRenderer.bind(this);
  }

  fileItemRenderer(file, isSelected, ref) {
    return (
      <ListItemView
        ref={ref}
        key={file.fullPath}
        isSelected={isSelected}
        onClick={this.props.onFileClick}
        clickContext={file.fullPath}
        middleElements={itemElement(file.name, file.displayPath)}
      />
    );
  }

  render() {
    const selectedIndex = -1;
    const onItemClick = newIndex =>
      this.props.onFileClick(this.props.fileList.find((item, index) => index === newIndex).fullPath);

    return (
      <div className="welcomeRecentFilesView">
        <ListView
          items={this.props.fileList}
          selectedItemIndex={selectedIndex}
          onItemSelect={onItemClick}
          itemRenderer={this.fileItemRenderer}
        />
      </div>
    );
  }
}

WelcomeFilesListView.propTypes = {
  fileList: PropTypeShapes.fileRecordList.isRequired,
  onFileClick: PropTypes.func.isRequired
};

export default WelcomeFilesListView;
